import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  Button,
  Drawer,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { useState } from "react";
import DeviceSearchForm from ".";

function DeviceFilter({ onSubmit, isSearchDisabled }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);

  if (!isMobile) {
    return (
      <DeviceSearchForm
        onSubmit={onSubmit}
        isSearchDisabled={isSearchDisabled}
      />
    );
  }

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<FilterListIcon />}
        onClick={() => setOpen(true)}
        sx={{ mb: 2, width: "100%", height: 48 }}
      >
        Search
      </Button>

      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => setOpen(false)}
        ModalProps={{
          keepMounted: true,
        }}
        PaperProps={{
          sx: {
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            p: 2,
          },
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography fontWeight={600}>Search</Typography>
          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <DeviceSearchForm
          onSubmit={(data) => {
            onSubmit(data);
            setOpen(false);
          }}
          isSearchDisabled={isSearchDisabled}
        />
      </Drawer>
    </>
  );
}

DeviceFilter.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isSearchDisabled: PropTypes.bool,
};

DeviceFilter.defaultProps = {
  isSearchDisabled: false,
};

export default DeviceFilter;
